import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { Paragraph, Link } from '@landr/maestro';
import { Trans } from '@lingui/macro';

export const ShareModalError: React.FC = (): JSX.Element => {
    return (
        <Paragraph color="text.medium">
            <Trans>
                We are currently not able to share your track. Please try again
                in a bit or{' '}
                <Link
                    href="https://support.landr.com"
                    target="_blank"
                    hasUnderline="hover"
                >
                    contact us
                </Link>{' '}
                if the problem persists.
            </Trans>
        </Paragraph>
    );
};
